"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.camelToSnake = void 0;
var CAMEL_CASE_MATCH = /([A-Z])/g;
/**
 * Converts a camelCase string to an underscore_string
 * @param {string} key String to convert
 */

var camelToSnake = function camelToSnake(key) {
  return key.replace(CAMEL_CASE_MATCH, function (chars) {
    return "_".concat(chars.toLowerCase());
  });
};

exports.camelToSnake = camelToSnake;
//# sourceMappingURL=camel-to-snake.js.map